import {
  FETCH_ALL_PARTNERS,
  FETCH_ALL_PARTNERS_SUCCESS,
  FETCH_ALL_PARTNERS_FAILURE,

  FETCH_PARTNER_BY_ID,
  FETCH_PARTNER_BY_ID_SUCCESS,
  FETCH_PARTNER_BY_ID_FAILURE,
  RESET_FETCH_PARTNER_BY_ID,

  FETCH_PARTNER_DASHBOARD_DETAILS,
  FETCH_PARTNER_DASHBOARD_DETAILS_SUCCESS,

  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILURE,

  ACTIVATE_PARTNER,
  ACTIVATE_PARTNER_SUCCESS,
  DEACTIVATE_PARTNER,
  DEACTIVATE_PARTNER_SUCCESS,

  EDIT_PARTNER,
  EDIT_PARTNER_SUCCESS,
  EDIT_PARTNER_FAILURE,

  RESET_ACTION_DIALOG,

  EXPORT_PARTNER,
  EXPORT_PARTNER_SUCCESS,
  PRINT_PARTNERS,
  PRINT_PARTNERS_SUCCESS,
  RESTORE_PARTNERS_INITIAL,
  MAKE_REQUEST_PARTNERS,
  FETCH_DIALOG_DATA,
  SEARCH_TABLE,
  DOWNLOAD_PARTNER_BULK_TEMPLATE,
  DOWNLOAD_PARTNER_BULK_TEMPLATE_SUCCESS,
  ADD_BULK_PARTNER,
  ADD_BULK_PARTNER_SUCCESS,
} from "../ActionTypes"


export const fetchAllPartners = payload => ({
  type: FETCH_ALL_PARTNERS,
  payload
})

export const fetchAllPartnersSuccess = payload => ({
  type: FETCH_ALL_PARTNERS_SUCCESS,
  payload
})

export const fetchAllPartnersFailure = payload => ({
  type: FETCH_ALL_PARTNERS_FAILURE,
  payload
})

export const fetchPartnerById = payload => ({
  type: FETCH_PARTNER_BY_ID,
  payload
})

export const fetchPartnerByIdSuccess = payload => ({
  type: FETCH_PARTNER_BY_ID_SUCCESS,
  payload
})

export const fetchPartnerByIdFailure = payload => ({
  type: FETCH_PARTNER_BY_ID_FAILURE,
  payload
})

export const resetFetchPartnerById = payload => ({
  type: RESET_FETCH_PARTNER_BY_ID,
  payload
})

export const fetchPartnerDashboardDetails = payload => ({
  type: FETCH_PARTNER_DASHBOARD_DETAILS,
  payload
})

export const fetchPartnerDashboardDetailsSuccess = payload => ({
  type: FETCH_PARTNER_DASHBOARD_DETAILS_SUCCESS,
  payload
})

export const createPartner = payload => ({
  type: CREATE_PARTNER,
  payload
})

export const createPartnerSuccess = payload => ({
  type: CREATE_PARTNER_SUCCESS,
  payload
})

export const createPartnerFailure = payload => ({
  type: CREATE_PARTNER_FAILURE,
  payload
})

export const resetActionDialog = payload => ({
  type: RESET_ACTION_DIALOG,
  payload
})

export const activatePartner = payload => ({
  type: ACTIVATE_PARTNER,
  payload
})

export const activatePartnerSuccess = payload => ({
  type: ACTIVATE_PARTNER_SUCCESS,
  payload
})

export const deactivatePartner = payload => ({
  type: DEACTIVATE_PARTNER,
  payload
})

export const deactivatePartnerSuccess = payload => ({
  type: DEACTIVATE_PARTNER_SUCCESS,
  payload
})

export const editPartner = payload => ({
  type: EDIT_PARTNER,
  payload
})

export const editPartnerSuccess = payload => ({
  type: EDIT_PARTNER_SUCCESS,
  payload
})

export const editPartnerFailure = payload => ({
  type: EDIT_PARTNER_FAILURE,
  payload
})

export const exportPartner = payload => ({
  type: EXPORT_PARTNER,
  payload
})

export const exportPartnerSuccess = payload => ({
  type: EXPORT_PARTNER_SUCCESS,
  payload
})

export const printPartners = payload => ({
  type: PRINT_PARTNERS,
  payload
})

export const printPartnersSuccess = payload => ({
  type: PRINT_PARTNERS_SUCCESS,
  payload
})

export const restorePartnersInitial = () => ({
  type: RESTORE_PARTNERS_INITIAL,
})

export const makeRequestPartners = () => ({
  type: MAKE_REQUEST_PARTNERS,
})

export const fetchDialogData = () => ({
  type: FETCH_DIALOG_DATA,
})

export const searchTable = () => ({
  type: SEARCH_TABLE,
})

// To download partners bulk template
export const downloadBulkPartner = () =>({
  type: DOWNLOAD_PARTNER_BULK_TEMPLATE,
})
export const downloadBulkPartnerSuccess = (payload) =>({
  type: DOWNLOAD_PARTNER_BULK_TEMPLATE_SUCCESS,
  payload
})

// To add bulk partner
export const addBulkPartner = () =>({
  type: ADD_BULK_PARTNER,
})
export const addBulkPartnerSuccess = (payload) =>({
  type: ADD_BULK_PARTNER_SUCCESS,
  payload
})